import { render, staticRenderFns } from "./chooseFieldsItem.vue?vue&type=template&id=1e8b762e&scoped=true"
import script from "./chooseFieldsItem.vue?vue&type=script&lang=js"
export * from "./chooseFieldsItem.vue?vue&type=script&lang=js"
import style0 from "./chooseFieldsItem.vue?vue&type=style&index=0&id=1e8b762e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8b762e",
  null
  
)

export default component.exports